import { Button, Stack } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useAnalytics } from "../../../../analytics/analytics";
import { ReleaseNotes } from "../../../../release-notes/release-notes";
import { AdditionalServicesSection } from "../additional-services-section";
import { ThemeAwareDivider } from "../divider";
import { DebugButton } from "./debug-button/debug-button";
import { NavHeader } from "./nav-header";
import { NavOptions } from "./nav-options";
import { NavPlannerOptions } from "./nav-planner-options";
import { NeedHelp } from "./need-help";
import type { NavigationProps } from "./types";

export const Navigation: FC<NavigationProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { gaEvent } = useAnalytics();

  return (
    <Stack sx={{ height: "100%" }}>
      <NavHeader onClose={onClose} />

      <Stack component="nav" spacing={2} sx={{ flexGrow: 1, px: 2 }}>
        <Button
          data-analytics-id="sidebar-create-content"
          fullWidth
          onClick={() => {
            gaEvent("multiformat_button", { action: "click", value: "Create Content" });
            void navigate({ pathname: "/create-content" });
          }}
          variant="contained"
        >
          {t("Create Content")}
        </Button>
        <ReleaseNotes />
        <NavOptions />
        <ThemeAwareDivider />
        <NavPlannerOptions />
        <AdditionalServicesSection />
        <DebugButton />
        <NeedHelp />
      </Stack>
    </Stack>
  );
};
